import DataTable from "react-data-table-component";

export default function SkillsTable(props) {
  const url = new URLSearchParams(window.location.search);
  const handleButtonClick = (e, row) => {
    url.set("id", row.id);
    window.history.pushState({}, "", `${window.location.pathname}?${url}`);
    props.updateSelectedSkills(row);
  };

  const columns = [
    {
      name: `Skill Id`,
      selector: (row) => row.id,
      sortable: true,
    },
    {
      name: `Skill Name`,
      selector: (row) => row.name,
      sortable: true,
    },
    {
      name: `Skill Label`,
      selector: (row) => row.label,
      sortable: true,
    },
    {
      cell: (row) => (
        <button
          className="bg-gray-700 p-2 text-base text-white"
          onClick={(e) => handleButtonClick(e, row)}
        >
          Edit
        </button>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];

  return (
    <div>
      <DataTable columns={columns} data={props.skillsData} pagination />
    </div>
  );
}
